const localStorageKeys = {
  sv: {
    selectedAirport: 'rbAirport',
  },
  zz: {
    favourites: 'solresorFavourites',
  },
  auth: {
    token: 'rb.auth.token',
    user: 'rb.auth.user',
    currentRoute: 'rb.auth.url',
    action: 'rb.auth.action',
    method: 'rb.auth.method',
    lock: 'rb.auth.lockstatus',
  },
  hideNewsletter: 'hideNL',
  identifiedUser: 'rbIdentifiedUser',
  extraLuggage: 'luggageStorage',
  singleFinderTempEnable: 'singleFinderTempEnable',
}

export default localStorageKeys

export { localStorageKeys }
